import { render, staticRenderFns } from "./Fontawesome.vue?vue&type=template&id=6dced055&"
import script from "./Fontawesome.vue?vue&type=script&lang=js&"
export * from "./Fontawesome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports